import React from "react";
import { Product, ProductCategory } from "./types";
import { BookingLanguage } from "@/types/booking";
import { PackageList } from "./PackageList";
import { PriceSummaryBox } from "./PriceSummaryBox";
import { BottomBar } from "./BottomBar";
import { useTranslation } from "react-i18next";
import { languageMap } from "@/i18n";

interface ProductSelectionContentProps {
  products: Product[];
  categories: ProductCategory[];
  selectedPackageId: string | null;
  onSelectPackage: (packageId: string) => void;
  localSelectedProducts: string[];
  onProductToggle: (productId: string) => void;
  selectedAddOns: string[];
  onAddOnToggle: (productId: string) => void;
  displayedPrice: number;
  animatePrice: boolean;
  language: BookingLanguage;
  onContinue?: () => void;
  onSelectPackageAndContinue?: (packageId: string) => void;
  /** Scan cards only: pick the package AND attach a membership. */
  onSelectPackageAsMember?: (packageId: string) => void;
}

export const ProductSelectionContent: React.FC<
  ProductSelectionContentProps
> = ({
  products,
  categories,
  selectedPackageId,
  onSelectPackage,
  localSelectedProducts,
  onProductToggle,
  selectedAddOns,
  onAddOnToggle,
  displayedPrice,
  animatePrice,
  language,
  onContinue,
  onSelectPackageAndContinue,
  onSelectPackageAsMember,
}) => {
  const { t } = useTranslation(undefined, { lng: languageMap[language] });

  // Translations for the bottom bar
  const translations = {
    continue: t("common.continue"),
    totalPrice: t("productStep.totalPrice"),
  };

  return (
    <>
      <PackageList
        products={products}
        selectedProductId={selectedPackageId}
        onSelectPackage={onSelectPackage}
        language={language}
        selectedAddOns={selectedAddOns}
        onAddOnToggle={onAddOnToggle}
        onSelectAndContinue={onSelectPackageAndContinue}
        onSelectAsMember={onSelectPackageAsMember}
        allProducts={products}
      />

      {/* Add bottom bar with continue button if onContinue is provided */}
      {onContinue && (
        <BottomBar
          totalPrice={displayedPrice}
          animatePrice={animatePrice}
          onContinue={onContinue}
          selectedProducts={selectedPackageId ? [selectedPackageId] : []}
          translations={translations}
          language={language}
        />
      )}
    </>
  );
};
